window.bootstrap = require('bootstrap')

import { Toast } from './_bootstrap';
import './charts/dashboard-summary';
import './charts/non-compliance-report';

(() => {
	// * Toast initialization, remove it if not necessary
	for (const toastElement of document.querySelectorAll(".toast")) {
		new Toast(toastElement);
	}
})();


(function($) {
    $(window).on("load",function () {
      //s  'use strict';



/* ///////////////////////////////////////
// info icons
*/ //////////////////////////////////////

$(".info-close").on( "click", function() {
  $(this).parent(".info-layer").fadeOut();
});

jQuery(".info-icon").on( "click", function() {
  jQuery('#' + jQuery(this).find('span').attr("class")).fadeIn();
});

/* ///////////////////////////////////////
// progress tracker
*/ //////////////////////////////////////

if(jQuery("form[id^='webform-submission-pillar']").find('input:checked').val() == "No"){
  jQuery(".progress-step.is-active").addClass("ValueNo");
};

/* ///////////////////////////////////////
// build level navigation
*/ //////////////////////////////////////

$("form[id^='webform-submission-pillar'] .webform-section-wrapper").prepend('<nav id="level-navigation" class="navbar"><h3 class="mb-0"><span class="d-none">Levels</span></h3><ul class="nav nav-pills"></ul></nav>');

var levelnavigation = '';
jQuery('.form-wrapper .radios--wrapper .description h3').each(function(){
  var itemID = $(this).parents('fieldset[id^="edit-level"]').find('[id^="edit-maturity-level"] .h2').text();
  const truncate = (str, max, suffix) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;
  var text = truncate(jQuery(this).text(), 128, '...');
  var radiovalue = jQuery(this).parents('fieldset').find('input:checked').val();
  var radioID = jQuery(this).parents('fieldset').attr('id');
  levelnavigation += '<li class="nav-item"><a class="nav-link value' + radiovalue + ' ' + radioID + '" href="#'+jQuery(this).parents('fieldset').parents('fieldset').attr('id')+'"><span>'+ itemID + "</span> " + text + '</a></li>';
});

jQuery( "#level-navigation ul.nav" ).append(
  levelnavigation
);
const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#level-navigation'
})

$("form[id^='webform-submission-pillar'] .radios--wrapper label").on( "click", function() {
  var radioclass = $(this).parents('fieldset').attr('id');
  var radioValue = $(this).prev("input").val();
  $('.' + radioclass).removeClass('valueYes valueNo').addClass('value' + radioValue);
} );
$("form[id^='webform-submission-pillar'] .link-reset").on( "click", function() {
  var radioclass = $(this).parents('div').prev('fieldset').attr('id');
  $('.' + radioclass).removeClass('valueYes valueNo');
} );


$( "#level-navigation a" ).on( "click", function() {
    var id = jQuery(this).attr('href');
  jQuery('html, body').animate({
    scrollTop: jQuery(id).offset().top - 100
  }, 200);
} );
$( "#level-navigation h3" ).on( "click", function() {
  $(this).parent('nav').toggleClass( "open" );
});


/* ///////////////////////////////////////
// https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
*/ //////////////////////////////////////

const growers = document.querySelectorAll(".grow-wrap");

growers.forEach((grower) => {
  const textarea = grower.querySelector("textarea");
  textarea.addEventListener("input", () => {
    grower.dataset.replicatedValue = textarea.value;
  });
});


/* ///////////////////////////////////////
// https://dotnetic.de/blog/disable-selected-option-if-selected-in-other-element
*/ //////////////////////////////////////

      function disableUsedOptions($table) {
        var $selects = $table.find("select");
        $selects.on("change", function() {
          $selects = $table.find("select");

          //console.log("In table:");
          //console.log($table);
          //console.log("there are " + $selects.length + " selects");
          if ($selects.length <= 1) return;
          let selected = [];

          $selects.each(function(index, select) {
            if (select.value !== "") {
              selected.push(select.value);
            }
          });

          //console.log("option values, that are being deactivated: " + selected);

          $table.find("option").prop("disabled", false);
          for (var index in selected) {
           $table
                      .find('option[value="' + selected[index] + '"]:not(:selected)')
                      .prop("disabled", true);
          }
        });
        $selects.trigger("change");
      }

      $(document).ready(function () {
          var $tables = $(".fieldset-priorities");
          $tables.each(function () {
              var $table = $(this);
              disableUsedOptions($table);
          });
      });


    }); /* END WINDOW LOAD */
}(jQuery));

